<template>
    <div>
        <div class="header">
            <!-- <div class="left-btn" @click="$router.go(-1)">
                <img :src="Images.icon_arrow_left">
            </div> -->
            <div class="search">
                <img :src="Images.icon_search" alt="">
                <input type="text" placeholder="输入关键字搜素" v-model="li_name">
                <div></div>
                <p @click="refresh()">搜索</p>
            </div>
        </div>
        <div class="screen">
            <div>
                <p>{{cate_name ? cate_name : '全部分类'}}</p>
            </div>
            <div>
                <p>默认</p>
            </div>
            <div @click="onPressSort('sales_count')">
                <p>销售</p>
                <div>
                    <img v-if="sales_count==='asc'" :src="Images.icon_arrow_top_blue" alt="">
                    <img v-else :src="Images.icon_arrow_top" alt="">
                    <img v-if="sales_count==='desc'" :src="Images.icon_arrow_bottom_blue" alt="">
                    <img v-else :src="Images.icon_arrow_down" alt="">
                </div>
            </div>
            <div @click="onPressSort('create_time')">
                <p>新品</p>
                <div>
                    <img v-if="create_time==='asc'" :src="Images.icon_arrow_top_blue" alt="">
                    <img v-else :src="Images.icon_arrow_top" alt="">
                    <img v-if="create_time==='desc'" :src="Images.icon_arrow_bottom_blue" alt="">
                    <img v-else :src="Images.icon_arrow_down" alt="">
                </div>
            </div>
            <div @click="onPressSort('price')">
                <p>价格</p>
                <div>
                    <img v-if="price==='asc'" :src="Images.icon_arrow_top_blue" alt="">
                    <img v-else :src="Images.icon_arrow_top" alt="">
                    <img v-if="price==='desc'" :src="Images.icon_arrow_bottom_blue" alt="">
                    <img v-else :src="Images.icon_arrow_down" alt="">
                </div>
            </div>
        </div>
        <div
            class="scrollerView"
            :style="{ height: (wrapperHeight- 116) + 'px' }"
        >
            <scroller
                :on-refresh="refresh"
                :on-infinite="infinite"
                :noDataText="dataSources.length > 1 ? Constants.ALL_LOAD_TIPS : ''"
                ref="infinite"
                class="scroller"
            >
                <div class="_scroller">
                    <goodsItem v-for="(item, index) in dataSources" :key="index" :item="item"/>
                </div>
                <van-empty description="暂无信息～" v-if="dataSources.length < 1 && !loading" />
            </scroller>
        </div>
    </div>
</template>

<script>
import goodsItem from '@/components/item/goodsItem'
export default {
    /** 组件挂载 */
    components: {
        'goodsItem': goodsItem,
    },
    /** 数据区 */
    data() {
        return {
            loading: false,
            shop_id: this.$route.query.shop_id,
            cate_id: this.$route.query.cate_id,
            cate_name: this.$route.query.cate_name,
            eq_shop_category_id: this.$route.query.eq_shop_category_id,
            wrapperHeight: 0, //屏幕高度 - 脚部
            page: 0,
            limit: 10,
            li_name: '',
            sales_count: '', // desc asc
            create_time: '', // desc asc
            price: '', // desc asc
            dataSources: [],
        };
    },
    /** 挂载后 */
    mounted() {
        this.wrapperHeight = document.documentElement.clientHeight;
    },
    /** 方法 */
    methods: {
        // 刷新
        refresh() {
            this.page = 1;
            this.requestData();
            setTimeout(function () {
                this.$refs.infinite.finishPullToRefresh();
            }.bind(this), 1000)
        },
        // 继续请求
        infinite() {
            this.page++
            this.requestData();
        },
        // 请求首页数据
        async requestData() {
            let url = this.API.shop_goods_list;
            let params = {
                page: this.page,
                limit: this.limit,
                li_name: this.li_name, // 商品名称
                eq_shop_id: this.shop_id, // 1商城一  2商城二
                eq_cate_id: this.cate_id, // 分类ID
                eq_shop_category_id: this.eq_shop_category_id, // 分类ID
                sales_count: this.sales_count, // desc asc
                create_time: this.create_time, // desc asc
                price: this.price, // desc asc
            };
            let result = await this.$post(url, params);
            let dataSourcesTemp = this.dataSources.slice();
            let dataList = result.data.data;
            let that = this;
            if (result.code === that.GLOBAL.SUCCESS_CODE) {
                if (that.page === 1) {
                    dataSourcesTemp = dataList
                    that._dataSource = result.data.data;
                } else {
                    if (dataList.length !== 0) {
                        dataSourcesTemp = dataSourcesTemp.concat(dataList)
                    }
                }
                that.dataSources = dataSourcesTemp
                that.$refs.infinite.finishInfinite(dataList.length < that.limit);
            } else {
                this.Message({
                    title: result.msg,
                });
            }
        },
        // 点击排序
        onPressSort(type) {
            let {sales_count, create_time, price} = this;
            switch (type) {
                case 'sales_count':
                    if (sales_count === '') {
                        this.sales_count = 'asc'
                    } else if (sales_count === 'asc') {
                        this.sales_count = 'desc'
                    } else {
                        this.sales_count = ''
                    }
                    break;
                case 'create_time':
                    if (create_time === '') {
                        this.create_time = 'asc'
                    } else if (create_time === 'asc') {
                        this.create_time = 'desc'
                    } else {
                        this.create_time = ''
                    }
                    break;
                case 'price':
                    if (price === '') {
                        this.price = 'asc'
                    } else if (price === 'asc') {
                        this.price = 'desc'
                    } else {
                        this.price = ''
                    }
                    break;
                default:
                    break;
            }
            this.refresh();
        },
    },
};
</script>

<style lang="less" scoped>

.scrollerView {
    position: relative;
    width: 100%;
}

.scroller {
    background: #F8F8F8;

    ._scroller {
        padding: 0 15px;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
    }
}

.header {
    position: relative;
    height: 60px;
    padding: 0 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #fff;

    .left-btn {
        width: 36px;
        height: 36px;
        position: absolute;
        top: 50%;
        left: 20px;
        transform: translateY(-50%);
        display: flex;
        justify-content: flex-start;
        align-items: center;

        img {
            display: block;
            height: 20px;
            opacity: .8;
        }
    }

    .search {
        flex: 1;
        padding: 0 10px;
        // margin-left: 30px;
        height: 34px;
        display: flex;
        align-items: center;
        background: #F5F5F5;
        border-radius: 5px;

        img {
            width: 14px;
            height: 14px;
        }

        input {
            flex: 1;
            margin-left: 10px;
            font-size: 14px;
            color: #333;
        }

        div {
            width: 1px;
            height: 15px;
            margin: 0 10px;
            background: #E1D9D9;
        }

        p {
            font-size: 14px;
            color: #666;
        }
    }
}

.screen {
    margin-top: 10px;
    padding: 0 15px;
    height: 46px;
    background: #fff;
    display: flex;

    > div {
        width: 20%;
        display: flex;
        align-items: center;
        justify-content: center;

        p {
            font-size: 15px;
            color: #333;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }

        > div {
            margin-left: 3px;
            display: flex;
            flex-direction: column;

            img {
                width: 8px;
                height: 8px; 
                object-fit: contain ;
            }
        }
    }
}
</style>